import config from '../config';

async function grantPermissions(email) {
  window.open(`${config.inStationGrantPermissionURL}&state=${email}`);

  return { success: undefined };
}

export default grantPermissions;
